import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/security-company-dashboard/src/environments/environment';
import { Loader } from '../enums/loader.enum';
import { Header } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class NotifyService {
  private readonly url = environment.api;
  constructor(private http: HttpClient) { }

  companyNotification(CompanyId: number, pageNumber: number, pageSize: number ,loader:Loader) {
    return this.http.get(
      this.url +
      `api/Notification/GetAllForSecurityCompany?securityCompanyId=${CompanyId}&page=${pageNumber}&pageSize=${pageSize}`, 
      {
        headers: {
          loader: loader,
        },
      }
     
    );
  }

  companyBranchNotification(
    CompanyBranchId: string,
    pageNumber: number,
    pageSize: number, loader:Loader
  ) {
    return this.http.get(
      this.url +
      `api/Notification/GetAllForSecurityCompanyBranch?securityCompanyBranchId=${CompanyBranchId}&page=${pageNumber}&pageSize=${pageSize}`, 
      {
        headers: {
          loader: loader,
        },
      }
   
    );
  }
  addNotification(model: any) {
    return this.http.post(
      this.url +
      `api/Notification/Create`, model,
      {
        headers: {
          loader: 'true',
        },
      }
    );
  }

  addNotify(data: any) {
    data.highlightWords = ''
    data.highlightWordsEn = ''
    data.paramters = ''
    data.notificationType = 1
    return this.http.post(this.url + `api/Notification/Create`, data)
  }


GetAllForSecurityCompanyCount(securityCompanyId:number){
  return this.http.get(
    this.url +
    `api/Notification/GetAllForSecurityCompanyCount?securityCompanyId=${securityCompanyId}`,{
      headers: {
        loader: 'false',
      },
    });
}


GetAllForSecurityCompanyBranchCount(securityCompanyBranchId:string){
  return this.http.get(
    this.url +
    `api/Notification/GetAllForSecurityCompanyBranchCount?securityCompanyBranchId=${securityCompanyBranchId}`,{
      headers: {
        loader: 'false',
      },
    });
}


}
